import { EllipsisMenuButton, Menu, MenuContent, MenuTrigger } from '@optiaxiom/react';

type ActionsCellProps = {
  onEdit: () => void;
  onDelete: () => void;
};

export const ActionsCell = ({ onEdit, onDelete }: ActionsCellProps) => {
  return (
    <Menu
      options={[
        {
          label: 'Edit',
          intent: 'neutral',
          execute: onEdit,
        },
        {
          label: 'Delete',
          intent: 'danger',
          execute: onDelete,
        },
      ]}
    >
      <MenuTrigger asChild>
        <EllipsisMenuButton appearance="subtle" />
      </MenuTrigger>
      <MenuContent />
    </Menu>
  );
};
